import { Play } from "lucide-react";
import { Reveal } from "./Reveal";
import { IMAGES, SITE } from "../constants/site";

const wa = `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(
  "Hi, please share the Sugee Lake District project walkthrough video."
)}`;

export default function Walkthrough() {
  return (
    <section id="walkthrough" data-testid="walkthrough-section" className="py-24 md:py-32 border-t border-border">
      <div className="max-w-screen-2xl mx-auto px-6">
        <Reveal>
          <p className="text-[11px] uppercase tracking-[0.35em] text-primary mb-5">Project Walkthrough</p>
          <h2 className="font-display font-light text-4xl md:text-5xl lg:text-6xl leading-tight mb-14">
            Step inside the <span className="italic text-primary">district</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <a
            href={wa}
            target="_blank"
            rel="noreferrer"
            data-testid="walkthrough-play-button"
            className="group relative block w-full overflow-hidden border border-border"
          >
            <img
              src={IMAGES.elevBase}
              alt="Sugee Lake District walkthrough"
              className="w-full h-[380px] md:h-[540px] object-cover group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-black/40 group-hover:bg-black/30 transition-colors" />
            <span className="absolute inset-0 flex items-center justify-center">
              <span className="relative flex h-20 w-20 items-center justify-center rounded-full bg-primary text-primary-foreground group-hover:scale-110 transition-transform duration-300">
                <span className="absolute inset-0 rounded-full bg-primary animate-pulse-ring" />
                <Play size={26} className="relative ml-1" />
              </span>
            </span>
            <span className="absolute bottom-6 left-6 text-[10px] uppercase tracking-[0.35em] text-white/80">
              Tap to get the walkthrough video on WhatsApp
            </span>
          </a>
        </Reveal>
      </div>
    </section>
  );
}
